module.exports = __webpack_public_path__ + "static/img/cer_not_banner.fb5dcf4a.png";